export const WELCOME_BACK_URL = '/welcome-back';
export const EARLY_FUNNEL_QUERY_PARAM = {
  key: 'is_early_funnel',
  value: 'true',
};
